export const ADDRESS = Object.freeze({
  DIFFERENT_ADDRESS_FROM_LOCATION: 'us_addr_not_country',
  GENERIC: 'generic.error',
  INVALID_ADDRESS: 'csz_x.city.state.zip',
  INVALID_AUPOST_QAS_ADDRESS: 'aupost_qas_invalid_address',
  INVALID_BILLING_ADDRESS_SELECTED: 'invalid_billing_address_selected',
  INVALID_CITY: 'csz_c.city',
  INVALID_DELIVERY_INSTRUCTIONS : 'match.address.delivery_instructions.args',
  INVALID_NAMES: 'name_components_invalid',
  INVALID_STATE: 'csz_s.state',
  INVALID_STATE_ZIP: 'invalid_zip.zip',
  INVALID_ZIP: 'csz_z.zip',
  INVALID_ZIP_FOR_PROVINCE: 'zp_z',
  TAX_PROVIDER_ERROR: 'tax_provider_lookup_failed',
});

export const GIFT_MESSAGE = Object.freeze({
  GENERIC: 'generic.error',
  PROFANIFY_FILTER: 'gift_message_profanity_filter_error',
});

export const PRODUCT = Object.freeze({
  REMOVED_ITEM_INACTIVE: 'removed_item',
  REMOVED_ITEM_SOLD_OUT: 'removed_item.sold_out',
});

export const RESTRICTION_ERRORS = Object.freeze({
  NAMED_DAY_DELIVERY_RESTRICTION: 'invalid.named_day',
  RESTRICTION_APO_ADDRESS: 'not_allowed.hazmat.address',
  RESTRICTION_APO_ADDRESS_MILITARY: 'not_allowed.hazmat.address.military',
  RESTRICTION_APO_ADDRESS_POBOX: 'not_allowed.hazmat.address.pobox',
  RESTRICTION_APO_ADDRESS_TERRITORY: 'not_allowed.hazmat.address.territory',
  RESTRICTION_OVERSEAS_TERRITORY: 'shipping_restriction.overseas_territory',
  RESTRICTION_ZIPCODE: 'not_allowed.hazmat.address.zipcode',
  SHIPPING_RESTRICTIONS_STATES: 'not_allowed.restricted_states',
  SHIPPING_UNAVAILABLE_FOR_ADDRESS: 'shipping.not_available',
});

export const RESTRICTED_ADDRESS_ERRORS = Object.values(RESTRICTION_ERRORS) as string[];

export const PAYMENT_ERRORS = Object.freeze({
  CANNOT_PROCESS: 'error.payment_provider_callback',
  CARD_NOT_RECOGNIZED: 'payment_provider.card_not_recognized', // TODO: This is tmp. Fix/Remove after <LATAMMAINT-9118> is completed.
  CART_CHANGED: 'error.cart_changed',
  CART_EMPTY: 'cart.empty',
  CC_EXPIRED: 'cc_expired',
  DELIVERY_EXPIRED: 'expired.delivery',
  GENERIC: 'generic.error',
  NO_CARD_INSTALLMENT: 'payment_provider.no_card_installment',
  NO_CARD_REDEMPTION: 'payment_provider.no_card_redemption',
  PAYMENT_ATTEMPTS_EXCEEDED: 'error.payment_attempts_exceeded',
  PAYMENT_DECLINED: 'payment_provider.declined',
  PAYMENT_PROVIDER_PROTOCOL_ERROR: 'payment_provider.protocol_error',
  PAYPAL_CANNOT_CONNECT: 'paypal.cannot.connect',
  REQUIRED_PRIVACY_POLICY: 'required.privacy.policy',
  THREE_DS: '3ds',
  TRANSACTION_FAILED: 'transaction.failure',
});

export const CART = Object.freeze({
  TRANSACTIONS_LIMIT: 'cart.trans_limit',
});

export const GENERAL = Object.freeze({
  GENERIC: 'generic.error',
});

export const GIFT_CARD = Object.freeze({
  UNAVAILABLE: 'provider_not_valid_with_giftcard',
  ZERO_BALANCE: 'giftcard_zero_balance',
});

export const SALON_COMMISSION = Object.freeze({
  INVALID_NAME: 'match.stylist_name.args',
});

export const SEVERITY_ABORT = 'ABORT';

export const REPLENISHMENT = 'autoreplenishment.removed';

export const OFFER_REMOVED = 'offer_criteria_not_met';
